import React, {Component} from 'react';
import { withRouter } from 'react-router-dom';

class SubmitTimeslotFail extends Component {

    constructor(props) {
        // Required step: always call the parent class' constructor
        super(props);
    }

    render(){
        const {resData} = this.props;

        return (
            <div className='content fail'>
                <div className='general-width margin-width-auto absolute-center'>
                    <div className='image-container'>
                        <span className="icon icon-link-expired apply-with-icon desktop">
                            <span className="path1"></span>
                            <span className="path2"></span>
                            <span className="path3"></span>
                            <span className="path4"></span>
                        </span>
                        <h2 className='header-text'>{window['i18n']['JOBSEEKER_TIME_SLOT_SUBMIT_FAIL_INFO_TITLE']}</h2>
                    </div>
                    <div className='message-container'>
                        <label className='x-large dark-tri'>
                        <h2 className='title-text'>{window['i18n']['JOBSEEKER_TIME_SLOT_SUBMIT_FAIL_INFO_TITLE']}</h2>
                        <div className='desc-text'>{window['i18n']['JOBSEEKER_TIME_SLOT_SUBMIT_FAIL_INFO']}</div>
                        <ul className='margin-top-x-large margin-left-regular desc-text'>
                            <li>{window['i18n']['JOBSEEKER_TIME_SLOT_SUBMIT_FAIL_1']}</li>
                            <li>{window['i18n']['JOBSEEKER_TIME_SLOT_SUBMIT_FAIL_2']}</li>
                            <li>{window['i18n']['JOBSEEKER_TIME_SLOT_SUBMIT_FAIL_3']}</li>
                        </ul>
                        <div className='margin-top-x-large desc-text'>{window['i18n']['JOBSEEKER_TIME_SLOT_SUBMIT_FAIL_END_1']}</div>
                        </label>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(SubmitTimeslotFail)